<template>
  <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Benutzer bearbeiten</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pb-1">
          <div class="row">

            <div class="col-md-4">
              <div class="info pl-3">
                <div class="inforow">
                  <label>E-Mail</label><span>{{ user.email }}</span>
                </div>
                <div class="inforow">
                  <label>Anrede</label><span>
                  <template v-if="user.gender == 0">
                    Herr
                  </template>
                  <template v-if="user.gender != 0">
                    Frau
                  </template>
                </span>
                </div>
                <div class="inforow">
                  <label>Vorname</label><span>{{user.firstname}}</span>
                </div>
                <div class="inforow">
                  <label>Nachname</label><span>{{user.lastname}}</span>
                </div>
                <div class="inforow">
                  <label>Firma</label><span>{{user.company}}</span>
                </div>
                <div class="inforow">
                  <label>Straße</label><span>{{user.street}}</span>
                </div>
                <div class="inforow">
                  <label>PLZ</label><span>{{user.zipcode}}</span>
                </div>
                <div class="inforow">
                  <label>Ort</label><span>{{user.city}}</span>
                </div>
                <div class="inforow">
                  <label>Land</label><span>{{user.country}}</span>
                </div>
                <div class="inforow">
                  <label>Beschreibung</label><span>{{user.description}}</span>
                </div>
                <div class="inforow">
                  <label>Sprache</label><span>{{user.language}}</span>
                </div>
                <div class="inforow">
                  <label>Geändert am</label><span>{{user.created}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="userstat">
                <div class="uslabel">Status</div>
                <div class="usdtls">
                  <div class="status"><span class="yellow"></span>Eingeladen</div>
                  <div class="status"><span class="blue" :class="{'c-status': user.active === 0}"></span>Bestätigt</div>
                  <div class="status"><span class="green" :class="{'c-status': user.active === 1}"></span>Aktiviert</div>
                  <div class="status"><span class="red" :class="{'c-status': user.active === 2}"></span>Gesperrt</div>
                </div>
              </div>
              <div class="userstat pl-1">
                <div class="uslabel">Rechte</div>
                <div class="usdtls">
                  <div class="form-check">
                    <input class="form-check-input" v-model="user.rights" type="radio" name="exampleRadios" id="exampleRadios13" value="1">
                    <label class="form-check-label" for="exampleRadios13">
                      Administrator
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" v-model="user.rights" type="radio" name="exampleRadios" id="exampleRadios1" value="2">
                    <label class="form-check-label" for="exampleRadios1">
                      Benutzer
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="user.rights" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios14" value="3">
                    <label class="form-check-label" for="exampleRadios14">
                      Gast
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 trades">
              <p class="mb-1"><b>Gewerk</b></p>
              <form id="trade-form">
              <ul class="border-top list-group-flush pt-0 screen-height selected-trades pl-0">
                <li class="pl-2 pb-0  list-group-item border-bottom" v-for="trade in checkedServices" :class="{'bg-gray': selectedServices.includes(trade.pdserviceid)}">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" :checked="selectedServices.includes(trade.pdserviceid)" class="custom-control-input"  @change="setServicesForUser($event,trade)" :id="'trade'+trade.pdserviceid">
                    <label class="custom-control-label custom-label pl-2 pt-0 pb-0" :for="'trade'+trade.pdserviceid">
                      {{trade.pdservicetitle}}
                    </label>
                  </div>
                </li>
              </ul>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer p-2">
          <div class="dokubtns text-right p-0">
            <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal">Abbrechen</button>
              <button type="button" @click="updateUserOfProject" class="btn btn-blue">
                Speichern
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
import axios from '../../utils/axiosinstance'

export default {
  props : ['user'],
  data(){
   return {
     params: []
   }
  },
  mounted () {

  },
  computed: {
    checkedServices () {
      if (this.user){
        return this.$store.state.appSettings.projectServices.filter(item => item.checked === 'true')
      }
    },
    selectedServices () {
      if (this.user.serviceselection){
        return this.user.serviceselection.map(item => item.pdserviceid)
      } else {
       return []
      }
    }
  },

  methods: {
   async updateUserOfProject(){
     let id = this.$route.params.id
     let _this = this
      $("#userModal").modal("toggle");
     _this.$store.commit('settingsModuleSetLoading',true)
     await this.setUserServices();
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "updateUserOfProject",
          "parameters": [this.user.pduserid,id,this.user],
          "serviceName": "ProjectdocuService"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
          _this.$toast.success('Benutzerdaten gespeichert');
      });
     _this.$store.commit('settingsModuleSetLoading',false)
    },

    setServicesForUser(event, trade){
      let checked = event.target.checked
      let param = [ this.$route.params.id , this.user.pduserid , checked ? "add" : "remove", trade ]
      let isSelected = this.selectedServices.includes(trade.pdserviceid)
      let isExist = this.params.find(trd => trd[3].pdserviceid === trade.pdserviceid)
      if (!isSelected && checked && !isExist){
        param[2] = "add"
        this.params.push(param)
      }
      if (isSelected && !checked &&!isExist){
        param[2] = "remove"
        this.params.push(param)
      }
      if (isExist && !checked && !isSelected){
        this.params = this.params.filter(sr => sr[3].pdserviceid !== trade.pdserviceid)
      }
      console.log(this.params,"here are the params")
    },

    async setUserServices () {
      for (let i = 0; i < this.params.length ; i++)
      {
        await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
          {
            "methodName": "setProjectUserServices",
            "parameters": this.params[i],
            "serviceName": "ProjectdocuService"
          },
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }).then(res => {
             //Service updated
        });
      }
    }
  },
  watch: {
    user: function () {
      document.getElementById('trade-form').reset();
      this.params = []
    }
  }
}
</script>
<style scoped>
.col-md-3.trades{
  max-height: 28rem;
  overflow-y: scroll;
}
.c-status{
  border: 2px solid;
  width: 14px;
  height: 14px;
}
.bg-gray{
  background-color: #f1f1f0;
}
.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
.main-tabs .custom-control-label::before, .main-tabs .custom-control-label::after {
  top: 1px;
}
.screen-height.selected-trades{
  height: calc(100vh - 220px);
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/UpdateUserModal.vue